import { Badge, Group, Text, Tooltip } from '@mantine/core';

export type OrganizationItem = {
  id: number;
  name: string;
};

export function formatOrganizationNames(
  organizations: OrganizationItem[] | null | undefined,
  separator = ', ',
): string {
  if (!organizations?.length) {
    return '';
  }

  return organizations.map((organization) => organization.name).join(separator);
}

export interface OrganizationsListProps {
  organizations?: OrganizationItem[] | null;
  maxVisible?: number;
  emptyPlaceholder?: string;
}

export function OrganizationsList({
  organizations,
  maxVisible = 3,
  emptyPlaceholder = '-',
}: OrganizationsListProps) {
  if (!organizations?.length) {
    return <Text c="dimmed">{emptyPlaceholder}</Text>;
  }

  const visible = organizations.slice(0, maxVisible);
  const hidden = organizations.slice(maxVisible);

  return (
    <Group gap={4} wrap="wrap">
      {visible.map((organization) => (
        <Badge
          color="gray"
          key={organization.id}
          size="sm"
          variant="light"
        >
          {organization.name}
        </Badge>
      ))}
      {hidden.length > 0 && (
        <Tooltip label={formatOrganizationNames(hidden)} withArrow>
          <Badge color="gray" size="sm" variant="light">
            +{hidden.length}
          </Badge>
        </Tooltip>
      )}
    </Group>
  );
}

export default OrganizationsList;
